import React, { useEffect } from "react";
import "./provisionsfreiPage.scss";
import ImmobilienvermittlungImage from "../../../assets/images/immobilienvermittlung.png";
import LeftSideContent from "./leftSideContent";
import CardContet from "./cardContet";
import { NavLink } from "react-router-dom";
export default function ProvisionsfreiPage() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div>
      <div className="immobilienvermittlung-section-alignment">
        <div className="left-side-content-alignment">
          <div className="grid">
            <div className="grid-items">
              <div className="text-grid  animate__fadeInLeft animate__animated">
                <div className="text-grid-items">
                  <div className="divider"></div>
                </div>
                <div className="text-grid-items">
                  <h1>Immobilienvermittlung provisionsfrei</h1>
                </div>
              </div>
              <p className="animate__fadeInUp animate__animated">
                Verkaufen oder vermieten Sie ihre Immobilie selbst und sparen
                Sie so die Provision - wir helfen Ihnen dabei.
              </p>
              <div className="outline-primary-button">
                <NavLink to="/kontakt">
                  <button>Kontakt aufnehmen</button>
                </NavLink>
              </div>
            </div>
            <div className="grid-items">
              <div className="image-style">
                <NavLink to="/kontakt">
                  <img
                    className="animate__backInUp animate__animated wow"
                    src={ImmobilienvermittlungImage}
                    alt="ImmobilienvermittlungImage"
                  />
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LeftSideContent />
      <CardContet />
    </div>
  );
}
